import React from 'react';
import { Button, Modal, Stack } from 'react-bootstrap';
import useCommonStore from 'store/common';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import parse from 'html-react-parser';

const SubscriptionAlertForPostJob: React.FC = () => {
	const { modalConfig = {}, hideCommonModal }: any = useCommonStore((state) => state);
	const { translate } = useTranslate();

	return (
		<Modal.Body>
			<div className="upgrade-subscription-plan">
				<div className="upgrade-subscription-plan-title text-center">
					<h4 className="fw-bold mb-1">{translate('Plan.upgradeToPremium')}</h4>
					<p className="mb-0">{parse(translate('Plan.planPageDescription'))}</p>
				</div>

				<Stack className="upgrade-subscription-plan-content">
					<div className="upgrade-plan-box">
						<p className="mb-0">{translate('Plan.doYouWantToPurchaseSubscription')}</p>
					</div>
				</Stack>

				<div className="upgrade-subscription-plan-action d-flex flex-column flex-sm-row align-items-center justify-content-between">
					<div className="d-flex align-items-center gap-2">
						<i className="ri-lock-line"></i>
						<p className="mb-0">{translate('Plan.paymentSecuredByStripe')}</p>
					</div>
					<div className="edit-modal-actions d-flex gap-3 gap-md-4 justify-content-center">
						<Button
							className="transparent-btn rounded-pill"
							onClick={() => (modalConfig?.onClose ? modalConfig?.onClose() : hideCommonModal())}
						>
							{translate('Modal.no')}
						</Button>
						<Button className="filled-btn rounded-pill" onClick={() => modalConfig?.onClick()}>
							{translate('Modal.yes')}
						</Button>
					</div>
				</div>
			</div>
		</Modal.Body>
	);
};

export default SubscriptionAlertForPostJob;
